import * as firebaseApp from 'firebase/app';

import 'firebase/analytics';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDpRVOr2c_1a1eqe1JvsYTAXSSKw4BkuvI',
  authDomain: 'podspast.firebaseapp.com',
  databaseURL: 'https://podspast.firebaseio.com',
  projectId: 'podspast',
  storageBucket: 'podspast.appspot.com',
  messagingSenderId: '323086346058',
  appId: '1:323086346058:web:a82d0f8f38bb14e2ad83b3',
  measurementId: 'G-9ESX8Z97BX'
};

firebaseApp.initializeApp(firebaseConfig);

export const firebase = firebaseApp;

export const firestore = firebaseApp.firestore();

export const analytics = firebase.analytics();
